import type { IProduct } from "#/types/iCardProduct";

export type OutOfStockItem = {
	front_item_id: string;
	available_amount: number;
};

export const applyOutOfStockToCart = (cartItems: IProduct[], outOfStockItems: OutOfStockItem[]): void => {
	for (const outOfStockItem of outOfStockItems) {
		const matchedIndex = cartItems.findIndex((cartItem) => cartItem.idSystem === outOfStockItem.front_item_id);
		if (matchedIndex === -1) continue;

		if (outOfStockItem.available_amount === 0) {
			cartItems.splice(matchedIndex, 1);
		} else {
			cartItems[matchedIndex].amount = outOfStockItem.available_amount;
		}
	}
};
